import { House,Search } from "react-bootstrap-icons";

const options =[
    // {
    //     label: "Inicio",
    //     defaultOption: true,
    //     icon: <House />,
    //     route: '/dashboard'
    // }
    {
        label: "Busqueda",
        defaultOption: true,
        icon: <Search />,
        route: '/search'
    }
];
export default options;